import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  actionType: {
    defaultMessage: 'Action Type',
    description: 'thing to move',
    id: 'maovkd',
  },
  stepTitleLabel: {
    description: 'Label for the step title input',
    defaultMessage: 'Step summary',
    id: 'pOL4vn',
  },
  stepTitlePlaceholder: {
    description: 'Placeholder for the step title input',
    defaultMessage: 'What does this step do?',
    id: 'UwRZFL',
  },
  filtersHeader: {
    description: 'Header for the filters section in step editor',
    defaultMessage: 'IF',
    id: 'nv4M98',
  },
  actionsHeader: {
    description: 'Header for the actions section in step editor',
    defaultMessage: 'THEN',
    id: 'PlEEk5',
  },
  addFilterButton: {
    description: 'Button text to add a new filter',
    defaultMessage: 'Add filter',
    id: 'Ho1LOG',
  },
  addActionButton: {
    description: 'Button text to add a new action',
    defaultMessage: 'Add action',
    id: '1k8GiV',
  },
  selectFilterType: {
    description: 'Placeholder for filter type dropdown',
    defaultMessage: 'Select condition...',
    id: 'WhD7lI',
  },
  selectActionType: {
    description: 'Placeholder for action type dropdown',
    defaultMessage: 'Select action...',
    id: 'mQNj65',
  },
  selectOperator: {
    description: 'Placeholder for operator dropdown',
    defaultMessage: 'Select...',
    id: 'tQ9zRf',
  },
  filterValuePlaceholder: {
    description: 'Placeholder for filter value input',
    defaultMessage: 'Enter value...',
    id: 'weAQpu',
  },
  actionValuePlaceholder: {
    description: 'Placeholder for action value input',
    defaultMessage: 'Enter value...',
    id: '9MWwo/',
  },
  incompleteConditionsBanner: {
    description: 'Banner shown when one or more filters or actions in a step are missing required fields',
    defaultMessage: '{count, plural, one {# condition requires configuration} other {# conditions require configuration}}',
    id: '+s5i3A',
  },
  removeFilterAriaLabel: {
    description: 'Aria label for the button that removes a filter row in the step editor',
    defaultMessage: 'Remove filter',
    id: '6JddwI',
  },
  removeActionAriaLabel: {
    description: 'Aria label for the button that removes an action row in the step editor',
    defaultMessage: 'Remove action',
    id: 'pN3dEc',
  },
});
